export enum Pkt {
  PKT_1 = 'PKT_1',
  PKT_2 = 'PKT_2',
  PKT_3 = 'PKT_3',
  PKT_4 = 'PKT_4',
  PKT_5 = 'PKT_5',
  PKT_6 = 'PKT_6',
}
